import usePylonChat from "@hooks/usePylonChat";

// Wrapper to be able to call hook from class component App
const PylonChat = () => {
  usePylonChat();
  return null;
};

export default PylonChat;
